import { render, staticRenderFns } from "./comRelSearch.vue?vue&type=template&id=db0f86fe&"
import script from "./comRelSearch.vue?vue&type=script&lang=js&"
export * from "./comRelSearch.vue?vue&type=script&lang=js&"
import style0 from "./comRelSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports